module.exports = __webpack_public_path__ + "img/transfer1.0be29f1d.png";